module.exports = __webpack_public_path__ + "static/img/icon1-5.a7c78d78.png";